<template>
	<div class="session-wrapper">
		<div class="session-right text-xs-center">
			<div class="session-table-cell">
				<div class="session-content">
					<img
						:src="appLogo"
						class="img-responsive mb-4"
						style="max-width: 300px;"
					/>
					<h2 class="mb-3">{{$t('lang.createAccount')}} — {{$t('lang.itsFree')}}</h2>
					<p>{{brand}} {{$t('lang.helpsEngineersContractors')}}</p>
					<v-form v-model="valid" class="mb-4">
						<v-text-field
							label="Username"
							v-model="name"
							:rules="nameRules"
							:counter="20"
							required
                            maxLength="15"
						></v-text-field>
						<v-text-field
							label="E-mail"
							v-model="email"
							:rules="emailRules"
							required
                            maxLength="100"
						></v-text-field>
						<v-text-field
							label="Password"
							v-model="password"
							:rules="passwordRules"
							type="password"
							required
                            maxLength="255"
						></v-text-field>
						<v-btn large @click="submit" block color="primary" class="fs-12 mb-4">{{$t('lang.signUp')}}</v-btn>
						<p class="fs-12 mb-4">{{$t('lang.bySigningUpYouAgreeTo')}} <router-link to="/legal/terms">{{$t('lang.termsOfService')}}</router-link> {{$t('lang.and')}} <router-link to="/legal/privacy">{{$t('lang.privacyPolicy')}}</router-link></p>

						<p class="fs-14">{{$t('lang.havingAnAccount')}}
							<router-link to="/session/login">{{$t('lang.signInNow')}}</router-link>
						</p>
					</v-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AppConfig from "Constants/AppConfig";

export default {
  data() {
    return {
      valid: false,
      name: "",
      nameRules: [
        v => !!v || "Name is required",
        v => v.length <= 20 || "Name must be less than 20 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail is required",
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid"
      ],
      password: "",
      passwordRules: [v => !!v || "Password is required"],
      appLogo: AppConfig.appLogo2,
      brand: AppConfig.brand
    };
  },
  methods: {
    submit() {
      if (this.valid) {
        let userDetail = {
          name: this.name,
          email: this.email,
          password: this.password
        };
        this.$store.dispatch("signupUserInFirebase", {
          userDetail,
          router: this.$router
        });
      }
    }
  }
};
</script>